AOS.init({
    duration: 500,
    offset: 20,
    easing: 'ease-in-out-quad',
    once: true
});

document.addEventListener('DOMContentLoaded', () => {
    // Mobile menu
    const dropdownToggles = document.querySelectorAll('#offcanvasMenuMobile .dropdown-toggle');
    if (dropdownToggles) {
        dropdownToggles.forEach(function (toggle) {
            toggle.addEventListener('click', function (event) {
                const dropdownMenu = toggle.nextElementSibling;
                const isOpen = dropdownMenu && dropdownMenu.classList.contains('show');

                const allDropdownMenus = document.querySelectorAll('#offcanvasMenuMobile .dropdown-menu.show');
                allDropdownMenus.forEach(function (menu) {
                    if (menu !== dropdownMenu) {
                        menu.classList.remove('show');
                    }
                });

                if (!isOpen) {
                    event.preventDefault();
                    if (dropdownMenu) {
                        dropdownMenu.classList.add('show');
                    }
                } else {
                    const href = toggle.getAttribute('href');
                    if (href && href !== '#') {
                        window.location.href = href;
                    } else {
                        event.preventDefault();
                    }
                }
            });
        });
    }

    // Overlap .lancio-container
    const handleLancioContainerOverlap = () => {
        const overlapContainer = document.querySelector('section.lancio-container.overlap');
        if (!overlapContainer) return;

        const nextSection = overlapContainer.nextElementSibling;
        if (!nextSection || nextSection.tagName.toLowerCase() !== 'section') return;

        if (!nextSection.dataset.originalPaddingTop) {
            const originalPadding = window.getComputedStyle(nextSection).paddingTop;
            nextSection.dataset.originalPaddingTop = originalPadding;
        }

        const updateOverlap = () => {
            const overlapHeight = overlapContainer.offsetHeight / 2;
            const originalPadding = parseFloat(nextSection.dataset.originalPaddingTop);

            nextSection.style.setProperty('margin-top', `-${overlapHeight}px`, 'important');
            nextSection.style.setProperty('padding-top', `${originalPadding + overlapHeight}px`, 'important');
        };

        updateOverlap();

        window.addEventListener('resize', updateOverlap);
    };
    handleLancioContainerOverlap();

    // Overlap mappa su footer
    function calculateMapExtension() {
        const map = document.querySelector('.dove-siamo-container #map');
        const targetElement = document.querySelector('footer li.orari');

        if (map && targetElement) {
            // Ottieni la posizione del container della mappa
            const mapContainerRect = map.parentElement.getBoundingClientRect();

            // Ottieni la posizione dell'elemento target nel footer
            const targetRect = targetElement.getBoundingClientRect();

            // Calcola l'offset necessario (distanza dalla fine del container alla posizione target)
            const footerOffset = targetRect.top + window.scrollY - (mapContainerRect.bottom + window.scrollY);

            // Imposta la variabile CSS personalizzata
            document.documentElement.style.setProperty('--map-footer-offset', footerOffset + 'px');

            // Calcola la distanza dal bordo destro del map al bordo destro della finestra
            const rightEdgeDistance = window.innerWidth - mapContainerRect.right;

            // Calcola la distanza dal bordo sinistro del map al bordo sinistro della finestra per mobile
            const leftEdgeDistance = mapContainerRect.left;
            document.documentElement.style.setProperty('--map-left-distance', leftEdgeDistance + 'px');

            // Imposta la width del map per estenderlo fino al bordo destro della pagina
            map.style.width = `calc(100% + ${rightEdgeDistance}px)`;
            map.style.marginRight = `-${rightEdgeDistance}px`;
        }
    }
    calculateMapExtension();
    window.addEventListener('resize', calculateMapExtension);
    window.addEventListener('load', calculateMapExtension);
});

document.addEventListener('DOMContentLoaded', function () {
    // Seleziona tutti i form di Contact Form 7
    const forms = document.querySelectorAll('.wpcf7-form');

    forms.forEach((form) => {
        // Intercetta l'evento di invio del form
        form.addEventListener('wpcf7submit', function (event) {
            // Ottieni lo stato e il messaggio dalla risposta
            const status = event.detail.status;
            const message = event.detail.apiResponse.message;

            // Mostra il messaggio in un modale personalizzato
            showCustomModal(status, message);

            // Nascondi il messaggio di risposta originale di CF7
            const responseOutput = form.querySelector('.wpcf7-response-output');
            if (responseOutput) {
                responseOutput.style.display = 'none';
            }
        });
    });

    // Funzione per mostrare il modale personalizzato
    function showCustomModal(status, message) {
        // Determina lo stile e il contenuto in base allo stato
        let iconColor = '';
        let svgIcon = '';
        let title = '';
        let buttonClass = '';

        if (status === 'mail_sent') {
            // Per il successo
            iconColor = '#00C13C'; // Verde brillante
            svgIcon = `<polyline points="20 6 9 17 4 12"></polyline>`;
            title = 'Grazie!';
            buttonClass = 'btn-success';
        } else if (status === 'validation_failed') {
            // Per warning
            iconColor = '#FFC107'; // Giallo warning
            svgIcon = `<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                 <line x1="12" y1="9" x2="12" y2="13"></line>
                 <line x1="12" y1="17" x2="12.01" y2="17"></line>`;
            title = 'Attenzione!';
            buttonClass = 'btn-secondary';
        } else {
            // Per error
            iconColor = '#DC3545'; // Rosso errore
            svgIcon = `<line x1="15" y1="9" x2="9" y2="15"></line>
                 <line x1="9" y1="9" x2="15" y2="15"></line>`;
            title = 'Errore';
            buttonClass = 'btn-secondary';
        }

        const circleIcon = `
      <div style="background-color: ${iconColor}; width: 56px; height: 56px; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin: 0 auto 20px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          ${svgIcon}
        </svg>
      </div>
    `;

        const modalHTML = `
      <div class="modal fade" id="cf7ResponseModal" tabindex="-1" aria-labelledby="cf7ResponseModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-center pt-0">
              ${circleIcon}
              <h5 class="modal-title" id="cf7ResponseModalLabel">${title}</h5>
              <p class="mt-2">${message}</p>
            </div>
            <div class="modal-footer justify-content-center">
              ${
                  status === 'mail_sent'
                      ? `<button type="button" class="btn btn-success" data-bs-dismiss="modal">OK</button>`
                      : `<button type="button" class="btn ${buttonClass}" data-bs-dismiss="modal">Chiudi</button>`
              }
            </div>
          </div>
        </div>
      </div>
    `;

        // Aggiungi il modale al DOM
        const modalContainer = document.createElement('div');
        modalContainer.innerHTML = modalHTML;
        document.body.appendChild(modalContainer);

        // Inizializza e mostra il modale
        const modalElement = document.getElementById('cf7ResponseModal');
        const bsModal = new bootstrap.Modal(modalElement);
        bsModal.show();

        // Rimuovi il modale dal DOM quando viene chiuso
        modalElement.addEventListener('hidden.bs.modal', function () {
            document.body.removeChild(modalContainer);
        });
    }
});

/**
 * ReviewShowMore - Sistema per gestire testi lunghi nelle recensioni
 * Implementazione allo stato dell'arte con supporto per Swiper
 */
document.addEventListener('DOMContentLoaded', function () {
    // Configurazione
    const config = {
        charactersLimit: 240, // Numero di caratteri da mostrare inizialmente
        expandText: 'Mostra di più', // Testo per il pulsante "espandi"
        collapseText: 'Mostra meno', // Testo per il pulsante "riduci"
        buttonClass: 'review-toggle', // Classe CSS per il pulsante
        expandedClass: 'expanded' // Classe CSS quando il testo è espanso
    };

    // Seleziona tutte le recensioni
    const recensioni = document.querySelectorAll('.testimonianza-testo');

    // Processa ogni recensione
    recensioni.forEach((recensione) => {
        const testoCompleto = recensione.innerHTML;
        const testoSemplice = recensione.textContent.trim();

        // Controlla se il testo supera il limite
        if (testoSemplice.length > config.charactersLimit) {
            // Genera una versione troncata del testo (preservando tag HTML)
            const testoTroncato = truncateHtml(testoCompleto, config.charactersLimit);

            // Crea il contenitore per il testo originale e il testo troncato
            const wrapperDiv = document.createElement('div');
            wrapperDiv.className = 'review-content';

            // Inserisci il testo troncato
            const testoTroncatoDiv = document.createElement('div');
            testoTroncatoDiv.className = 'review-truncated';
            testoTroncatoDiv.innerHTML = testoTroncato;
            wrapperDiv.appendChild(testoTroncatoDiv);

            // Inserisci il testo completo (inizialmente nascosto)
            const testoCompletoDiv = document.createElement('div');
            testoCompletoDiv.className = 'review-full';
            testoCompletoDiv.innerHTML = testoCompleto;
            testoCompletoDiv.style.display = 'none';
            wrapperDiv.appendChild(testoCompletoDiv);

            // Crea il pulsante "Mostra di più"
            const toggleButton = document.createElement('button');
            toggleButton.className = config.buttonClass;
            toggleButton.textContent = config.expandText;
            toggleButton.setAttribute('type', 'button');
            toggleButton.setAttribute('aria-expanded', 'false');

            // Sostituisci il contenuto della recensione
            recensione.innerHTML = '';
            recensione.appendChild(wrapperDiv);
            recensione.appendChild(toggleButton);

            // Gestisci il click sul pulsante
            toggleButton.addEventListener('click', function () {
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                const testoTroncatoEl = this.parentNode.querySelector('.review-truncated');
                const testoCompletoEl = this.parentNode.querySelector('.review-full');

                if (isExpanded) {
                    // Riduci il testo
                    fadeElements(testoCompletoEl, testoTroncatoEl);
                    this.textContent = config.expandText;
                    this.setAttribute('aria-expanded', 'false');
                    recensione.classList.remove(config.expandedClass);
                } else {
                    // Espandi il testo
                    fadeElements(testoTroncatoEl, testoCompletoEl);
                    this.textContent = config.collapseText;
                    this.setAttribute('aria-expanded', 'true');
                    recensione.classList.add(config.expandedClass);
                }

                // Aggiorna Swiper per adattarsi alle nuove dimensioni
                updateSwiper();
            });
        }
    });

    /**
     * Aggiorna lo swiper quando il contenuto cambia dimensione
     */
    function updateSwiper() {
        if (window.testimonianzeSwipers) {
            window.testimonianzeSwipers.forEach((element) => {
                if (element.swiper) {
                    element.swiper.update();
                }
            });
        }
    }

    /**
     * Cambia la visibilità di due elementi senza animazione
     * @param {HTMLElement} hideElement - Elemento da nascondere
     * @param {HTMLElement} showElement - Elemento da mostrare
     */
    function fadeElements(hideElement, showElement) {
        // Nascondi immediatamente il primo elemento
        hideElement.style.display = 'none';

        // Mostra immediatamente il secondo elemento
        showElement.style.display = 'block';
    }

    /**
     * Tronca HTML mantenendo la struttura dei tag
     * @param {string} html - HTML da troncare
     * @param {number} limit - Limite di caratteri
     * @return {string} HTML troncato
     */
    function truncateHtml(html, limit) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Funzione ricorsiva per contare e troncare il testo
        function truncateNode(node, charsLeft) {
            if (charsLeft <= 0) return 0;

            // Gestisci i nodi di testo
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent;
                if (text.length <= charsLeft) {
                    return text.length;
                } else {
                    node.textContent = text.slice(0, charsLeft - 3) + '...';
                    return 0;
                }
            }

            // Gestisci elementi HTML
            if (node.nodeType === Node.ELEMENT_NODE) {
                let total = 0;
                const childNodes = Array.from(node.childNodes);

                for (const child of childNodes) {
                    const remaining = charsLeft - total;
                    if (remaining <= 0) {
                        node.removeChild(child);
                    } else {
                        const consumed = truncateNode(child, remaining);
                        total += consumed;
                        if (consumed === 0) break;
                    }
                }

                return total;
            }

            return 0;
        }

        truncateNode(tempDiv, limit);
        return tempDiv.innerHTML;
    }
});
